import Toptal from "../assets/toptal.svg";
import Deel from "../assets/deel.svg";
import Freelancer from "../assets/freelancer.svg";
import Upwork from "../assets/upwork.svg";

export default function Majorplatform() {
  return (
    <div className="mt-[140px] flex flex-col px-4 lg:px-[10%] justify-center items-center">
      <p className="text-center text-4xl text-[#1A202C] px-[5%] font-bold">
        Collect payments from all major platforms
      </p>

      <div className="grid grid-cols-1  lg:grid-cols-4 gap-x-[-200px] gap-y-6 mt-10 w-full max-w-6xl md:px-[20%] lg:px-[1%] justify-items-center">
        <div className="bg-[#edf2f8] rounded-2xl flex items-center justify-center h-36 w-60 transition-all duration-300 group">
          <img src={Upwork} alt="Upwork" className="w-32 h-16 object-contain" loading="lazy" />
        </div>
        <div className="bg-[#edf2f8] rounded-2xl flex items-center justify-center h-36 w-60 transition-all duration-300 group">
          <img src={Deel} alt="Deel" className="w-28 h-16 object-contain" loading="lazy" />
        </div>
        <div className="bg-[#edf2f8] rounded-2xl flex items-center justify-center h-36 w-60 transition-all duration-300 group">
          <img src={Toptal} alt="Toptal" className="w-32 h-16 object-contain" loading="lazy" />
        </div>
        <div className="bg-[#edf2f8] rounded-2xl flex items-center justify-center h-36 w-60 transition-all duration-300 group">
          <img src={Freelancer} alt="Freelancer" className="w-40 h-16 object-contain"loading="lazy"/>
        </div>
      </div>
    </div>
  );
}
